
<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import AppFooter from "@/examples/Footer.vue";


const store = useStore();
const layout = computed(() => store.state.layout);
const showFooter = computed(() => store.state.showFooter);

</script>
<template>
  <div
    v-show="layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>

 

  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
  >
   

    <router-view />

    <app-footer v-show="showFooter" />

   
  </main>
</template>
<style>
body , div , p , span {
  font-family: "Kanit", sans-serif;
}
.f-weight-600{
font-weight: 600;
}
.f-weight-500{
font-weight: 500;
}
.f-weight-400{
font-weight: 400;
}
.f-weight-300{
font-weight: 300;
}
.f-weight-200{
font-weight: 200;
}

label.form-control-label{
  color: #64748B;
  font-size: 14px;
  font-weight: 400;
}
</style>